import React, { useContext, useState } from "react";

import "./cardCommentActivity.scss";
import GlobalContext from "../../../contexts/globalContext";
interface CardCommentActivityInter {
  comment: any;
  handleNewCommentModal: any;
  userId: any;
  setCurrentId: any;
  setValueInput: any;
}

const CardCommentActivity = (props: CardCommentActivityInter) => {
  const { comment, handleNewCommentModal, userId } = props;
    const { gigyaContext: { gigyaAccount } } = useContext(GlobalContext);

  const [showModalDelete, setShowModalDelete] = useState<any>(false);

  const deleteHandler = async (idComment) => {
    const URL = process.env.URL_BIBLIOTECAS_SERVICES;
    const optionUser = confirm("¿Seguro desea eliminar el comentario?");

    if (optionUser === true) {
      await fetch(
        `${URL}/community/api/v1/response?responseId=${idComment}&email=${gigyaAccount?.profile.email}`,
        {
          method: "DELETE",
        }
      );
      window.location.reload();
    }
  };

  return (
    <div
      className="a-card-comment-activity"
      onClick={() => {
        if (showModalDelete) setShowModalDelete(false);
      }}
    >
      <div className="a-card-comment-activity__img">
        <img
          src={comment.imagenPrincipal[0].file.url}
          alt={`Foto ${comment.name}`}
        />
      </div>

      <div className="a-card-comment-activity__content">
        <div className="a-card-comment-activity__content-info">
          <p className="a-card-comment-activity__content-info__name">
            {comment.name}
          </p>
          <p className="a-card-comment-activity__content-info__date">
            {comment.date}
          </p>
          {userId === props.comment.data.user.id &&
            props.userId !== "5fbfacc3dbf3e04c82adedd8" && (
              <div
                className="a-card-comment-activity__content-info__edit"
                style={{ paddingLeft: "25px", width: "80px" }}
              >
                <p
                  className="a-card-comment-activity__content-info__edit-edit icon-edit"
                  onClick={() => {
                    props.setValueInput(comment.data.summary);
                    props.setCurrentId(props.comment.data.id);
                    setShowModalDelete(false);
                    handleNewCommentModal(true);
                  }}
                ></p>

                <p
                  className="a-card-comment-activity__content-info__edit-delete icon-trash-alt"
                  id="modal-delete"
                  onClick={() => {
                    deleteHandler(comment.data.id);
                  }}
                ></p>
              </div>
            )}
        </div>

        <div className="a-card-comment-activity__content-comment">
          <p>{comment.data.summary}</p>
        </div>
      </div>
    </div>
  );
};

export default CardCommentActivity;
